<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-job-position-job-title-dialog-create
          v-if="$hasPermissionTo([
            'update job title approval level',
            'create job titles'
          ])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Job Title's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in job title value here"
          append-icon="search"
          label="Search Job title"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredPositions"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.job_grade="{ item }">
        <div>
          <span>
            {{ ((item||{}).job_grade||{}).name || 'N/A' }}
          </span>
        </div>
      </template>

      <template v-slot:item.job_group="{ item }">
        <div>
          <span>
            {{ (((item||{}).job_grade||{}).job_group||{}).name || 'N/A' }}
          </span>
        </div>
      </template>

      <template v-slot:item.job_category="{ item }">
        <div>
          <span>
            {{ (((item||{}).job_grade||{}).job_category||{}).name || 'N/A' }}
          </span>
        </div>
      </template>

      <template v-slot:item.job_band="{ item }">
        <div>
          <span>
            {{ (((item||{}).job_grade||{}).job_band||{}).value || 'N/A' }}
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-job-position-job-title-dialog-edit-approval
            v-if="$hasPermissionTo(['view job title approval level'])"
            :position="item" 
            @updated="loadData"
          /> 
          <setup-job-position-job-title-dialog-edit
            v-if="$hasPermissionTo(['update job titles'])" 
            :position="item" 
            @updated="loadData"
          /> 
          <setup-job-position-job-title-dialog-delete
            v-if="$hasPermissionTo(['delete job titles'])" 
            :position="item"
            @deleted="loadData"
          /> 
        </span>
        <span v-else>
          <setup-job-position-job-title-dialog-restore
            v-if="$hasPermissionTo(['restore job titles'])" 
            :position="item" 
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobTitleDialogEditApproval: () => import('@/components/hris/setup/job-position/job-title/DialogEditApproval'),
      SetupJobPositionJobTitleDialogCreate: () => import('@/components/hris/setup/job-position/job-title/DialogCreate'),
      SetupJobPositionJobTitleDialogEdit: () => import('@/components/hris/setup/job-position/job-title/DialogEdit'),
      SetupJobPositionJobTitleDialogDelete: () => import('@/components/hris/setup/job-position/job-title/DialogDelete'),
      SetupJobPositionJobTitleDialogRestore: () => import('@/components/hris/setup/job-position/job-title/DialogRestore'),
    },
    data () {
      return {
        positions: [],
        trashedPositions: [],
        headers: [
          {
            text: 'Position',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Job Grade',
            align: 'left',
            value: 'job_grade',
          },
          {
            text: 'Job Group',
            align: 'left',
            value: 'job_group',
          },
          {
            text: 'Job Category',
            align: 'left',
            value: 'job_category',
          },
          {
            text: 'Job Band',
            align: 'left',
            value: 'job_band',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredPositions () {
        return this.statusFilter ? this.positions : this.trashedPositions
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.positions().list(),
          this.$api.positions().listTrashed(),
        ]).then(([positions, trashedPositions]) => {
          this.positions = positions.data
          this.trashedPositions = trashedPositions.data
     
          this.tableLoading = false
        })
      },
    },
  }
</script>
